<script setup>
import {MagnifyingGlassIcon, XMarkIcon} from "@heroicons/vue/24/outline";
import IconButton from "@/components/ui/IconButton.vue";
import useKeyboardInput from "@/composables/useKeyboardInput";
import { onMounted, ref, defineEmits, watch } from 'vue';

const inputRef = ref(null)
const { text: kbText, onFocus, onBlur, onTextChange, clear} = useKeyboardInput("", { inputName: "search" });
const emit = defineEmits(['input', 'update:modelValue'])

const onClickClear = () => {
  clear()
  if(inputRef.value) inputRef.value.focus()
}

onMounted(() => {
  onTextChange((newText) => {
    emit('input', newText)
  });
})

watch(() => kbText.value, (newText) => {
  emit('update:modelValue', newText)
})

</script>

<template>
  <div class="flex items-center justify-start gap-2 w-full h-6 px-4">
    <MagnifyingGlassIcon class="size-5 text-black/60"/>
    <input autocomplete="off" ref="inputRef" v-model="kbText" @focus="onFocus" @blur="onBlur" placeholder="Suche nach einem Ort..." class="flex-1 appearance-none border-none !bg-transparent p-0 m-0 focus:outline-none placeholder-gray-600"/>
    <IconButton :icon="XMarkIcon" v-show="kbText.length > 0" @click="onClickClear"/>
  </div>
</template>

<style scoped>

</style>